module.exports = __webpack_public_path__ + "cdd4ac5a0441eb4823c0cc8ac120de5e.MP3";